/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  'saq',
  [
    ['Tesiran', 'Teipa'],
    ,
  ],
  ,
  [
    ['A', 'K', 'O', 'I', 'I', 'S', 'K'], ['Are', 'Kun', 'Ong', 'Ine', 'Ile', 'Sap', 'Kwe'],
    [
      'Mderot ee are', 'Mderot ee kuni', 'Mderot ee ong’wan', 'Mderot ee inet', 'Mderot ee ile',
      'Mderot ee sapa', 'Mderot ee kwe'
    ],
    ['Are', 'Kun', 'Ong', 'Ine', 'Ile', 'Sap', 'Kwe']
  ],
  ,
  [
    ['O', 'W', 'O', 'O', 'I', 'I', 'S', 'I', 'S', 'T', 'T', 'T'],
    ['Obo', 'Waa', 'Oku', 'Ong', 'Ime', 'Ile', 'Sap', 'Isi', 'Saa', 'Tom', 'Tob', 'Tow'],
    [
      'Lapa le obo', 'Lapa le waare', 'Lapa le okuni', 'Lapa le ong’wan', 'Lapa le imet',
      'Lapa le ile', 'Lapa le sapa', 'Lapa le isiet', 'Lapa le saal', 'Lapa le tomon',
      'Lapa le tomon obo', 'Lapa le tomon waare'
    ]
  ],
  , [['KK', 'BK'], , ['Kabla ya Christo', 'Baada ya Christo']], 0, [6, 0],
  ['dd/MM/y', 'd MMM y', 'd MMMM y', 'EEEE, d MMMM y'],
  ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'],
  [
    '{1} {0}',
    ,
    ,
  ],
  ['.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
  ['#,##0.###', '#,##0%', '¤#,##0.00', '#E0'], 'Ksh', 'Njilingi eel Kenya', function(n: number):
                                                                                number {
                                                                                  if (n === 1)
                                                                                    return 1;
                                                                                  return 5;
                                                                                }
];
